<div class="flex flex-column align-items-center justify-content-center">
  <img
    [src]="cell.product.img"
    [alt]="cell.product.name"
    style="width: 100%; height: 100%; object-fit: scale-down"
  />

  <div class="min-w-full">
    <textarea
      rows="5"
      cols="30"
      style="width: 100%;"
      pInputTextarea
      [(ngModel)]="cell.notes"
    ></textarea>
   
  </div>
  <div class="flex flex-row align-content-between justify-content-between mt-2 min-w-full">
    <p-button
    label="{{'FORM.SAVE' | translate}}"
    icon="pi pi-check"
    [raised]="true"
    [severity]="'success'"
    (onClick)="saveNote()"
    [disabled]="!cell.notes"
  >
  </p-button>
    <p-button
      label="{{'NOTES.DELETE' | translate}}"
      icon="pi pi-times"
      [raised]="true"
      [severity]="'danger'"
      (onClick)="cancelNote()"
    >
    </p-button>
  </div>
</div>
